import { render, staticRenderFns } from "./ExpertTalk.vue?vue&type=template&id=7f12aa92&scoped=true"
import script from "./ExpertTalk.vue?vue&type=script&lang=js"
export * from "./ExpertTalk.vue?vue&type=script&lang=js"
import style0 from "./ExpertTalk.vue?vue&type=style&index=0&id=7f12aa92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f12aa92",
  null
  
)

export default component.exports